export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/event_videos.466be31.svg";